<workspace-breadcrumb />
@if (lifeTimeEarningsResource.status() === 'error' || growingGanasResource.status() === 'error') {
  @if (lifeTimeEarningsResource.status() === 'error') {
    <app-resource-load-error
      data-resource="lifetime"
      message="balance.lifetimeEarningsLoadError"
      (retry)="lifeTimeEarningsResource.reload()"
    />
  }
  @if (growingGanasResource.status() === 'error') {
    <app-resource-load-error
      data-resource="growing"
      message="balance.growingGanasLoadError"
      (retry)="growingGanasResource.reload()"
    />
  }
} @else if (topCardLoading()) {
  <div class="relative min-h-[10rem]">
    <korviu-loader />
  </div>
} @else {
  @if (lifetimeEarnings()?.lifetime_earnings > 0) {
    <div class="card p-8 flex flex-col items-center gap-4">
      <div>
        <div class="text-[#222528] text-[1.625rem] font-bold">{{ 'balance.potential_ganas' | translate }}</div>
        <div class="text-[#737980] text-[1.125rem]">{{ growingGanasAvailabilityLabel() }}</div>
      </div>
      <div class="flex flex-col gap-6">
        <div class="relative">
          <apx-chart
            #chart
            [series]="donutChartOptions().series"
            [chart]="donutChartOptions().chart"
            [colors]="donutChartOptions().colors"
            [plotOptions]="donutChartOptions().plotOptions"
            [dataLabels]="donutChartOptions().dataLabels"
            [fill]="donutChartOptions().fill"
            [stroke]="donutChartOptions().stroke"
            [legend]="donutChartOptions().legend"
            [states]="donutChartOptions().states"
          ></apx-chart>
          <div class="absolute w-full h-full top-0 left-0 flex items-center justify-center">
            <div class="flex flex-col items-center gap-[0.16rem]">
              <div class="text-[1.9375rem]/[140%] text-[#2C3035] font-bold">
                {{ growingGanas()?.total_ganas || 0 }}
              </div>
              <div class="text-[1.125rem]/[160%] text-[#737980]">{{ 'balance.ganas' | translate }}</div>
            </div>
          </div>
        </div>
        <div class="flex gap-4 items-center w-full justify-center">
          <div class="flex gap-1 items-center">
            <div class="rounded-[0.125rem] bg-[#007DCB] size-[0.875rem]"></div>
            <span class="text-[0.9375rem]/[160%] text-[#505760]">{{ growingGanasLabels().mySpending }}</span>
          </div>
          <div class="flex gap-1 items-center">
            <div class="rounded-[0.125rem] bg-[#8AC3E7] size-[0.875rem]"></div>
            <span class="text-[0.9375rem]/[160%] text-[#505760]">{{ growingGanasLabels().myCommunity }}</span>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-2 items-center">
        @if (growingGanasTrendDisplay()) {
          <div class="flex gap-1 items-center">
            <div class="text-[#505760] text-[1.125rem]">{{ growingGanasTrendDisplay() }}</div>
            @if (isGrowingGanasTrendUp() || isGrowingGanasTrendDown()) {
              <i
                class="flex"
                [style.transform]="isGrowingGanasTrendDown() ? 'rotate(90deg)' : null"
                [style.transformOrigin]="'center'"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <path
                    d="M14.2489 6L21.8027 6.00052L21.903 6.01444L22.0018 6.04205L22.0621 6.0676C22.1413 6.10246 22.2155 6.15315 22.2808 6.21836L22.3215 6.2624L22.365 6.31878L22.4192 6.4089L22.4579 6.49922L22.477 6.5633L22.4906 6.6273L22.5 6.7215L22.5004 14.2539C22.5004 14.6681 22.1647 15.0039 21.7504 15.0039C21.3708 15.0039 21.057 14.7217 21.0073 14.3557L21.0004 14.2539L21 8.559L13.2812 16.2793C13.0149 16.5455 12.5982 16.5698 12.3046 16.3519L12.2205 16.2793L9.25001 13.3089L3.78033 18.7786C3.48744 19.0715 3.01256 19.0715 2.71967 18.7786C2.4534 18.5123 2.4292 18.0957 2.64705 17.8021L2.71967 17.7179L8.71967 11.7179C8.98593 11.4517 9.40259 11.4275 9.6962 11.6453L9.78032 11.7179L12.7508 14.6883L19.938 7.5H14.2489C13.8692 7.5 13.5554 7.21785 13.5058 6.85177L13.4989 6.75C13.4989 6.3703 13.7811 6.05651 14.1472 6.00685L14.2489 6Z"
                    [attr.fill]="growingGanasTrendColor()"
                  />
                </svg>
              </i>
            }
          </div>
        }
        <div class="text-[#737980] text-[0.9375rem]">
          {{ 'balance.showingGanasFromCurrentSpendingPeriod' | translate }}
        </div>
      </div>
    </div>
  } @else {
    <div class="card-shadow py-12 px-8 relative overflow-hidden">
      <div class="flex flex-col gap-4 max-w-[21.625rem] relative z-1">
        <div class="text-[0.9375rem] text-[#505760]">{{ 'balance.youHaveNoEarningsYetShort' | translate }}</div>
        <div class="flex flex-col gap-2">
          <div class="text-[#2C3035] text-[1.375rem] font-bold">
            {{ 'balance.getExtraFundsFromYourCommunitysCardUse' | translate }}
          </div>
          <div class="text-[#505760] text-[1.125rem]">{{ 'balance.referFriendsAndFamilyAndEarn' | translate }}</div>
        </div>
      </div>
      <img
        src="../../../../../assets/img/balance/EmptyEarningsDesktop.webp"
        class="absolute right-0 bottom-0 w-auto h-[112%]"
        alt=""
      />
    </div>
  }

  @if (lifetimeEarnings()?.lifetime_earnings > 0) {
    <div class="px-6 py-4 flex gap-4 items-center card-shadow mt-6">
      <div class="flex flex-col flex-1">
        <span class="text-[1.125rem] text-[#2C3035] font-bold">{{
          'balance.seeYourCommunitysImpact' | translate
        }}</span>
        <span class="text-[0.9375rem] text-[#505760]">{{ 'balance.earnGanasEveryTimeSomeone' | translate }}</span>
      </div>
      <div>
        <img src="../../../../../assets/img/balance/impact.svg" />
      </div>
    </div>
  } @else {
    <button
      type="button"
      (click)="okeeyCardStatusService.open()"
      class="okeey-card-cta w-full text-left px-6 py-4 flex gap-4 items-center card-shadow mt-6"
    >
      <div class="flex min-w-0 flex-col flex-1 leading-[1.6]">
        <span class="text-base md:text-[1.125rem] text-[#2C3035] font-bold">{{
          'balance.getTheOkeeyCashCard' | translate
        }}</span>
        <span class="text-[0.8125rem] md:text-[0.9375rem] text-[#505760]">{{
          'balance.okeeyCardPausedTitle' | translate
        }}</span>
      </div>
      <div class="flex shrink-0 items-center gap-2 md:gap-4" aria-hidden="true">
        <img class="okeey-card-cta__illustration" src="assets/img/okee.svg" alt="" />
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M4.81313 2.81246C4.61787 3.00772 4.61787 3.32431 4.81313 3.51957L9.29289 7.99935L4.81313 12.4791C4.61787 12.6744 4.61787 12.9909 4.81313 13.1862C5.0084 13.3815 5.32494 13.3815 5.5202 13.1862L10.3536 8.35288C10.5488 8.15761 10.5488 7.84108 10.3536 7.64581L5.5202 2.81246C5.32494 2.6172 5.0084 2.6172 4.81313 2.81246Z"
            fill="#8A8E94"
          />
        </svg>
      </div>
    </button>
  }
}

<div class="table mt-6 w-full overflow-hidden p-3 md:p-4">
  <div class="grid grid-cols-2 md:grid-cols-4">
    @for (column of TABLE_COLUMNS; track column.key) {
      @if (column.desktopOnly) {
        <div
          class="table__header hidden bg-[#E6F2FA] px-4 py-3 text-[0.9375rem] font-bold text-[#2C3035] md:block md:px-6 md:py-2"
        >
          {{ column.label | translate }}
        </div>
      } @else {
        <div class="table__header bg-[#E6F2FA] px-4 py-3 text-[0.9375rem] font-bold text-[#2C3035] md:px-6 md:py-2">
          {{ column.label | translate }}
        </div>
      }
    }
  </div>
  @if (earningsTableResource.status() === 'error') {
    <app-resource-load-error data-resource="table" (retry)="earningsTableResource.reload()" />
  } @else if (earningsTableLoading()) {
    <div class="relative min-h-[8rem]">
      <korviu-loader />
    </div>
  } @else {
    @for (row of visibleEarningsTableRows(); track row.period) {
      <div class="grid grid-cols-2 border-b border-[#EEEEEF] last:border-b-0 md:grid-cols-4">
        @for (column of TABLE_COLUMNS; track column.key) {
          @if (column.desktopOnly) {
            <div class="table__cell hidden px-4 py-4 text-[0.9375rem] text-[#393E44] md:block md:px-6 md:py-2">
              {{ row[column.key] }}
            </div>
          } @else {
            <div class="table__cell px-4 py-4 text-[0.9375rem] text-[#393E44] md:px-6 md:py-2">
              {{ row[column.key] }}
            </div>
          }
        }
      </div>
    }
    @if (earningsTableRows().length > earningsTablePageSize) {
      <nz-pagination
        class="pagination mt-6 flex justify-center"
        [nzPageIndex]="earningsTablePage()"
        [nzPageSize]="earningsTablePageSize"
        [nzTotal]="earningsTableRows().length"
        [nzHideOnSinglePage]="true"
        [nzSize]="'small'"
        (nzPageIndexChange)="onEarningsTablePageChange($event)"
      />
    }
  }
</div>

<!-- Новый график заработанных Ganas -->
<div class="card p-6 mt-6">
  <div class="flex flex-col gap-4">
    <div>
      <div class="flex items-center gap-2">
        <div class="text-[#222528] text-[1.625rem] font-bold">{{ 'balance.ganasEarned' | translate }}</div>
        <button
          type="button"
          class="flex shrink-0 rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#007DCB]"
          data-testid="earnings-category-info"
          nz-tooltip
          appHideTooltipOnScroll
          [nzTooltipTitle]="earningsCategoryTooltip"
          nzTooltipPlacement="right"
          [attr.aria-label]="'balance.earningsByCategoryTooltipLabel' | translate"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12.0016 2C17.5253 2 22.0031 6.47784 22.0031 12.0016C22.0031 17.5253 17.5253 22.003 12.0016 22.003C6.47784 22.003 2 17.5253 2 12.0016C2 6.47784 6.47784 2 12.0016 2ZM12.0016 3.5C7.30627 3.5 3.5 7.30627 3.5 12.0016C3.5 16.6969 7.30627 20.503 12.0016 20.503C16.6969 20.503 20.5031 16.6969 20.5031 12.0016C20.5031 7.30627 16.6969 3.5 12.0016 3.5ZM11.9979 10.5006C12.3776 10.5003 12.6916 10.7823 12.7415 11.1484L12.7484 11.2501L12.752 16.7517C12.7523 17.1659 12.4167 17.502 12.0025 17.5022C11.6228 17.5025 11.3088 17.2205 11.2589 16.8545L11.252 16.7527L11.2484 11.251C11.2482 10.8369 11.5837 10.5009 11.9979 10.5006ZM12.002 7.00281C12.5536 7.00281 13.0007 7.44993 13.0007 8.00148C13.0007 8.55302 12.5536 9.00014 12.002 9.00014C11.4505 9.00014 11.0034 8.55302 11.0034 8.00148C11.0034 7.44993 11.4505 7.00281 12.002 7.00281Z"
              fill="#8A8E94"
            />
          </svg>
        </button>
        <ng-template #earningsCategoryTooltip>
          <div class="flex max-w-[18rem] flex-col gap-2">
            @for (category of earningsCategories(); track category.key) {
              <div>
                <strong>{{ category.label }}:</strong>
                {{ category.tooltipKey | translate }}
              </div>
            }
          </div>
        </ng-template>
      </div>
      <div class="text-[#737980] text-[1.125rem]">{{ 'balance.12months' | translate }}</div>
    </div>
    <div>
      @if (earningsByCategoryResource.status() === 'error') {
        <app-resource-load-error data-resource="category" (retry)="earningsByCategoryResource.reload()" />
      } @else if (earningsByCategoryLoading()) {
        <div class="relative min-h-[18rem]">
          <korviu-loader />
        </div>
      } @else {
        <ng-scrollbar class="w-full" visibility="hover" appearance="compact">
          <div class="w-[57rem] overflow-hidden">
            <div class="-ml-6 w-[60rem]">
              <apx-chart
                [series]="earningsBarChartOptions().series"
                [chart]="earningsBarChartOptions().chart"
                [colors]="earningsBarChartOptions().colors"
                [plotOptions]="earningsBarChartOptions().plotOptions"
                [xaxis]="earningsBarChartOptions().xaxis"
                [yaxis]="earningsBarChartOptions().yaxis"
                [grid]="earningsBarChartOptions().grid"
                [legend]="earningsBarChartOptions().legend"
                [dataLabels]="earningsBarChartOptions().dataLabels"
                [tooltip]="earningsBarChartOptions().tooltip"
                [states]="earningsBarChartOptions().states"
              />
            </div>
          </div>
        </ng-scrollbar>
      }
    </div>
    <div class="flex flex-wrap gap-4 items-center w-full justify-center" data-testid="earnings-category-legend">
      @for (category of earningsCategories(); track category.key) {
        <div class="flex gap-1 items-center">
          <div class="rounded-[0.125rem] size-[0.875rem]" [style.background-color]="category.color"></div>
          <span class="text-[0.9375rem]/[160%] text-[#505760]">{{ category.label }}</span>
        </div>
      }
    </div>
  </div>
</div>

<div class="w-full mt-6 flex flex-col md:flex-row gap-6">
  <div class="flex flex-col gap-6 flex-1 min-w-0">
    <!-- Lifetime Earnings -->
    <div class="card flex flex-col gap-4 px-8 py-6 gap-4 rounded-[0.25rem] items-center">
      <div class="size-[2.5rem] p-2 bg-[#E6F2FA] flex items-center justify-center rounded-[0.5rem]">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M18.5 0C19.4665 0 20.25 0.78351 20.25 1.75V4.79271C20.25 5.81687 19.6809 6.75618 18.7731 7.2303L12.4913 10.5107C14.1273 11.3324 15.25 13.0258 15.25 14.9814C15.25 17.7428 13.0114 19.9814 10.25 19.9814C7.48858 19.9814 5.25 17.7428 5.25 14.9814C5.25 13.0258 6.37271 11.3324 8.00875 10.5107L1.72693 7.2303C0.81913 6.75618 0.25 5.81687 0.25 4.79271V1.75C0.25 0.78351 1.0335 0 2 0H18.5ZM10.25 11.4814C8.317 11.4814 6.75 13.0484 6.75 14.9814C6.75 16.9144 8.317 18.4814 10.25 18.4814C12.183 18.4814 13.75 16.9144 13.75 14.9814C13.75 13.0484 12.183 11.4814 10.25 11.4814ZM13.75 1.499H6.75V8.16098L10.1343 9.92888C10.2068 9.96678 10.2932 9.96678 10.3657 9.92888L13.75 8.15998V1.499ZM5.25 1.499L2 1.5C1.86193 1.5 1.75 1.61193 1.75 1.75V4.79271C1.75 5.25824 2.00869 5.6852 2.42133 5.90071L5.25 7.377V1.499ZM18.5 1.5L15.25 1.499V7.377L18.0787 5.90071C18.4913 5.6852 18.75 5.25824 18.75 4.79271V1.75C18.75 1.61193 18.6381 1.5 18.5 1.5Z"
            fill="#007DCB"
          />
        </svg>
      </div>
      <div class="flex flex-col gap-1 items-center">
        <span class="text-[#505760] text-[1.125rem]">{{ 'balance.lifetimeEarnings' | translate }}</span>
        @if (lifeTimeEarningsResource.status() === 'error') {
          <app-resource-load-error data-resource="lifetime" (retry)="lifeTimeEarningsResource.reload()" />
        } @else {
          <span class="text-[#2C3035] text-[1.9375rem] font-bold">{{
            lifetimeEarnings() ? (lifetimeEarnings()?.lifetime_earnings ?? 0) + ' Ganas' : '—'
          }}</span>
        }
      </div>
    </div>

    <!-- Bonus received -->
    <div
      class="card-shadow px-6 pt-4 pb-6 flex flex-col items-center gap-6 min-h-[21.625rem]"
      data-testid="bonus-received"
    >
      <div class="w-full text-[1.375rem] font-bold text-center md:text-left">
        {{ 'balance.bonusReceived' | translate }}
      </div>
      @if (lifeTimeEarningsResource.status() === 'error') {
        <app-resource-load-error data-resource="bonus" (retry)="lifeTimeEarningsResource.reload()" />
      } @else if (lifetimeEarningsLoading()) {
        <div class="relative min-h-[10rem] w-full"><korviu-loader /></div>
      } @else if (bonusGanas() === 0) {
        <div class="flex flex-col gap-4 items-center max-w-[17rem]">
          <img src="../../../../../assets/img/balance/empty-bonus.svg" class="size-[7.75rem]" alt="" />
          <div class="text-[0.9375rem] text-[#737980] text-center">
            {{ 'balance.discoverMissionsAndPromotions' | translate }}
          </div>
        </div>
      } @else {
        <div class="flex flex-1 flex-col justify-center items-center gap-4 max-w-[17rem]">
          <span class="text-[#2C3035] text-[1.9375rem] font-bold" data-testid="bonus-received-total">{{
            bonusGanasDisplay()
          }}</span>
          <p class="mb-0 text-[0.9375rem] text-[#737980] text-center">
            {{
              (bonusGanas() === null ? 'balance.bonusEarningsUnavailable' : 'balance.bonusGanasCategoryTooltip')
                | translate
            }}
          </p>
        </div>
      }
      <korviu-button type="link" link="/workspace/promotions" color="ghost">
        <span linkText>{{ 'profile.goToPromotions' | translate }}</span>
      </korviu-button>
    </div>
  </div>

  <!-- Top Contributors -->
  <div class="flex-1 flex flex-col items-center">
    <div class="flex flex-col items-center">
      <div class="text-[#2C3035] text-[1.625rem] font-bold">{{ 'balance.topContributors' | translate }}</div>
      <div class="text-[#007DCB] text-[1.125rem]">
        {{ topContributorsPeriodLabel() || ('balance.thisMonth' | translate) }}
      </div>
    </div>
    @if (topContributorsResource.status() === 'error') {
      <app-resource-load-error data-resource="contributors" (retry)="topContributorsResource.reload()" />
    } @else if (topContributorsLoading()) {
      <div class="relative min-h-[8rem] w-full"><korviu-loader /></div>
    } @else if (topContributorsResolved() && !!topContributorRows().length) {
      <div class="mt-8 flex flex-col gap-3">
        @for (contributor of topContributorRows(); track contributor.user_id; let index = $index) {
          @let place = contributor.rank || index + 1;
          <div class="flex items-center">
            @if (place <= 3) {
              @if (place === 1) {
                <div class="size-[2.5rem] p-2 bg-[#F8D185] flex items-center justify-center rounded-[0.5rem] mr-3">
                  <i>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                      <path
                        d="M10.001 0.166016C15.1551 0.166231 19.333 4.3449 19.333 9.49902C19.3329 12.0413 18.3167 14.3463 16.668 16.0293L16.666 25.8311C16.6659 26.5933 15.8573 27.0579 15.21 26.7217L15.0898 26.6484L9.99902 23.0654L4.91113 26.6484C4.28775 27.0874 3.44232 26.6939 3.34473 25.9707L3.33594 25.8311L3.33398 16.0293C1.68512 14.3463 0.668075 12.0413 0.667969 9.49902C0.667969 4.34477 4.84672 0.166016 10.001 0.166016ZM14.666 17.583C13.2936 18.3766 11.7004 18.831 10.001 18.8311C8.30137 18.8311 6.70749 18.3767 5.33496 17.583V23.9033L9.42383 21.0244C9.72586 20.8119 10.1164 20.785 10.4404 20.9443L10.5742 21.0244L14.666 23.9043V17.583ZM10.001 2.16602C5.9512 2.16602 2.66797 5.44924 2.66797 9.49902C2.66818 13.5487 5.95133 16.8311 10.001 16.8311C14.0505 16.8308 17.3328 13.5485 17.333 9.49902C17.333 5.44938 14.0506 2.16623 10.001 2.16602ZM11.0557 5.49902V14.5205H9.84668V6.59082H8.00098V5.49902H11.0557Z"
                        fill="#674F1F"
                      />
                    </svg>
                  </i>
                </div>
              } @else if (place === 2) {
                <div class="size-[2.5rem] p-2 bg-[#C9CBCE] flex items-center justify-center rounded-[0.5rem] mr-3">
                  <i>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="27" viewBox="0 0 19 27" fill="none">
                      <path
                        d="M9.33301 0C14.4871 0.000214917 18.665 4.17889 18.665 9.33301C18.6649 11.8752 17.6488 14.1803 16 15.8633L15.998 25.665C15.998 26.4273 15.1893 26.8919 14.542 26.5557L14.4219 26.4824L9.33105 22.8994L4.24316 26.4824C3.61978 26.9214 2.77435 26.5278 2.67676 25.8047L2.66797 25.665L2.66602 15.8633C1.01715 14.1803 0.000106232 11.8753 0 9.33301C0 4.17875 4.17875 0 9.33301 0ZM13.998 17.417C12.6256 18.2106 11.0325 18.665 9.33301 18.665C7.63341 18.665 6.03953 18.2107 4.66699 17.417V23.7373L8.75586 20.8584C9.05789 20.6459 9.44839 20.619 9.77246 20.7783L9.90625 20.8584L13.998 23.7383V17.417ZM9.33301 2C5.28323 2 2 5.28323 2 9.33301C2.00022 13.3826 5.28336 16.665 9.33301 16.665C13.3825 16.6648 16.6648 13.3825 16.665 9.33301C16.665 5.28336 13.3826 2.00021 9.33301 2ZM9.41016 4.33301C9.95928 4.33305 10.4356 4.43938 10.8389 4.65234C11.2509 4.8654 11.5688 5.16436 11.792 5.54785C12.015 5.93124 12.126 6.37854 12.126 6.88965C12.126 7.25608 12.0788 7.58428 11.9844 7.87402C11.8986 8.16362 11.7404 8.46194 11.5088 8.76855C11.2856 9.06683 10.9718 9.42519 10.5684 9.84277L8.20312 12.2588H12.332V13.332H6.33301V12.6035L9.62891 9.15234C9.96354 8.81157 10.2253 8.5176 10.4141 8.27051C10.6028 8.0149 10.7362 7.7804 10.8135 7.56738C10.8993 7.35433 10.9424 7.13244 10.9424 6.90234C10.9424 6.45072 10.7957 6.09745 10.5039 5.8418C10.2121 5.58613 9.83458 5.45801 9.37109 5.45801C8.91628 5.45803 8.5171 5.56851 8.17383 5.79004C7.83055 6.00307 7.52582 6.33552 7.25977 6.78711L6.41016 6.08398C6.76203 5.50461 7.18683 5.06998 7.68457 4.78027C8.18239 4.482 8.75785 4.33301 9.41016 4.33301Z"
                        fill="#494F57"
                      />
                    </svg>
                  </i>
                </div>
              } @else if (place === 3) {
                <div class="size-[2.5rem] p-2 bg-[#F8B88A] flex items-center justify-center rounded-[0.5rem] mr-3">
                  <i>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="27" viewBox="0 0 19 27" fill="none">
                      <path
                        d="M9.33301 0C14.4871 0.000214917 18.665 4.17889 18.665 9.33301C18.6649 11.8752 17.6488 14.1803 16 15.8633L15.998 25.665C15.998 26.4273 15.1893 26.8919 14.542 26.5557L14.4219 26.4824L9.33105 22.8994L4.24316 26.4824C3.61978 26.9214 2.77435 26.5278 2.67676 25.8047L2.66797 25.665L2.66602 15.8633C1.01715 14.1803 0.000106232 11.8753 0 9.33301C0 4.17875 4.17875 0 9.33301 0ZM13.998 17.417C12.6256 18.2106 11.0325 18.665 9.33301 18.665C7.63341 18.665 6.03953 18.2107 4.66699 17.417V23.7373L8.75586 20.8584C9.05789 20.6459 9.44839 20.619 9.77246 20.7783L9.90625 20.8584L13.998 23.7383V17.417ZM9.33301 2C5.28323 2 2 5.28323 2 9.33301C2.00022 13.3826 5.28336 16.665 9.33301 16.665C13.3825 16.6648 16.6648 13.3825 16.665 9.33301C16.665 5.28336 13.3826 2.00021 9.33301 2ZM12.2471 6.06055L9.77051 8.86816C9.77279 8.86816 9.77507 8.86816 9.77734 8.86816C10.2626 8.86816 10.6959 8.98174 11.0771 9.20703C11.467 9.43228 11.7747 9.74815 12 10.1553C12.234 10.5625 12.3515 11.035 12.3516 11.5723C12.3516 12.1442 12.2129 12.6518 11.9355 13.0938C11.6669 13.5269 11.2939 13.8689 10.8174 14.1201C10.3408 14.3628 9.78592 14.4844 9.15332 14.4844C8.56423 14.4843 8.02716 14.3757 7.54199 14.1592C7.06545 13.9339 6.66228 13.6091 6.33301 13.1846L7.16504 12.3525C7.36428 12.6556 7.63701 12.8982 7.9834 13.0801C8.33004 13.2534 8.71599 13.3398 9.14062 13.3398C9.53926 13.3398 9.88199 13.2665 10.168 13.1191C10.4623 12.9632 10.6919 12.7468 10.8564 12.4697C11.0297 12.1925 11.1162 11.8716 11.1162 11.5078C11.1162 11.1353 11.0297 10.8145 10.8564 10.5459C10.6918 10.2686 10.4576 10.0555 10.1543 9.9082C9.85106 9.76099 9.49101 9.6875 9.0752 9.6875C8.91935 9.68752 8.76326 9.70059 8.60742 9.72656C8.52949 9.73523 8.45272 9.74754 8.37695 9.7627L8.15234 9.81738V9.07617L10.4824 6.4248H6.76172V5.33301H12.2471V6.06055Z"
                        fill="#833701"
                      />
                    </svg>
                  </i>
                </div>
              }
            } @else {
              <div class="size-[2.5rem] p-2 flex items-center justify-center rounded-[0.5rem] mr-3">
                <span class="text-[#674F1F] font-bold">{{ place }}</span>
              </div>
            }
            @if (contributor.avatarUrl) {
              <img [src]="contributor.avatarUrl" class="size-[3.5rem] rounded-full mr-4 object-cover" alt="" />
            } @else {
              <div class="size-[3.5rem] rounded-full bg-[#000] mr-4"></div>
            }
            <div class="flex flex-col gap-2 mr-4 flex-1">
              <div class="text-[#2C3035] text-[1.125rem]">
                {{
                  contributor.isDeleted
                    ? ('common.deletedAccount' | translate: { id: contributor.user_id })
                    : contributor.name
                }}
              </div>
              <div class="text-[#505760] text-[0.9375rem]">{{ contributor.user_type }}</div>
            </div>
            <div class="text-[#505760] text-[0.9375rem]">{{ contributor.contribution_display }}</div>
          </div>
        }
      </div>
    } @else {
      <div class="flex flex-col gap-4 max-w-[17.25rem] items-center mt-20 mb-8">
        <img src="../../../../../assets/img/balance/empty-flower.svg" class="size-[7.75rem]" alt="" />
        <div class="text-[0.9375rem] text-[#737980] text-center">{{ 'balance.yourGanarbolsAreYour' | translate }}</div>
      </div>
      <div>
        <korviu-button color="tertiary" (onclick)="inviteReferral()">{{
          'my-referrals.inviteReferral' | translate
        }}</korviu-button>
      </div>
    }
  </div>
</div>
